<template>
    <div class="flight-passengers" v-if="product.Pax.length > 0">
        <Passenger
            v-for="(pax, index) in product.Pax"
            :product="product"
            :bagsIncluded="bagsIncluded"
            :key="index"
            :index="index"
            :pax="pax" />
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { FlightProduct } from '@/api/Cart/cart.interfaces';
    import { IncludedBaggages } from '@shared/interfaces/baggage';
    import { getIncludedBaggages } from '@shared/helpers/baggage';
    import Passenger from '../Passenger/Passenger.vue';

    export default defineComponent({
        name: 'FlightModalDetailsPassengers',
        components: { Passenger },
        props: {
            product: {
                type: Object as PropType<FlightProduct>,
                required: true,
            },
        },
        setup(props) {
            const bagsIncluded = computed<IncludedBaggages>(() =>
                getIncludedBaggages(props.product)
            );

            return {
                bagsIncluded,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Passengers';
</style>
